import academicApi from '@/services/plataforma/academic';

export default {
  getUsers({ commit }, categories) {
    if (!categories.length) {
      return;
    }
    return academicApi.getUsers(categories)
      .then((response) => {
        return Promise.resolve(response.data.enrollmentList);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  getRoles({ commit }) {
    return academicApi.getRoles()
      .then((response) => {
        return Promise.resolve(response.data.roles);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  },
  getCourses(_, { isToGetOnlyActual = false } = {}) {
    return academicApi.getCourses({ isToGetOnlyActual })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((e) => {
        return Promise.reject(e.response.data.error.message);
      });
  }
};
